export enum EnvironmentType {
    Local = 'Local',
    Dev = 'Dev',
    QA = 'QA',
    Test = 'Test',
    Prod = 'Prod'
}